import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=bc5e5c20&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=bc5e5c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5e5c20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc5e5c20')) {
      api.createRecord('bc5e5c20', component.options)
    } else {
      api.reload('bc5e5c20', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=bc5e5c20&scoped=true&", function () {
      api.rerender('bc5e5c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Se0fUePUQDoA/JS/comp/PopupBox.vue"
export default component.exports